/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CodeFrame } from './CodeFrame';
import {
    CodeFrameFromJSON,
    CodeFrameFromJSONTyped,
    CodeFrameToJSON,
} from './CodeFrame';

/**
 * 
 * @export
 * @interface ComputationSchema
 */
export interface ComputationSchema {
    /**
     * 
     * @type {number}
     * @memberof ComputationSchema
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ComputationSchema
     */
    schedulerId: number;
    /**
     * 
     * @type {Date}
     * @memberof ComputationSchema
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof ComputationSchema
     */
    stop?: Date;
    /**
     * 
     * @type {string}
     * @memberof ComputationSchema
     */
    code: string;
    /**
     * 
     * @type {Array<CodeFrame>}
     * @memberof ComputationSchema
     */
    callstack?: Array<CodeFrame>;
}

/**
 * Check if a given object implements the ComputationSchema interface.
 */
export function instanceOfComputationSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "schedulerId" in value;
    isInstance = isInstance && "start" in value;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function ComputationSchemaFromJSON(json: any): ComputationSchema {
    return ComputationSchemaFromJSONTyped(json, false);
}

export function ComputationSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComputationSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'schedulerId': json['scheduler_id'],
        'start': (new Date(json['start'])),
        'stop': !exists(json, 'stop') ? undefined : (new Date(json['stop'])),
        'code': json['code'],
        'callstack': !exists(json, 'callstack') ? undefined : ((json['callstack'] as Array<any>).map(CodeFrameFromJSON)),
    };
}

export function ComputationSchemaToJSON(value?: ComputationSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'scheduler_id': value.schedulerId,
        'start': (value.start.toISOString()),
        'stop': value.stop === undefined ? undefined : (value.stop.toISOString()),
        'code': value.code,
        'callstack': value.callstack === undefined ? undefined : ((value.callstack as Array<any>).map(CodeFrameToJSON)),
    };
}

